import { game } from '../main';
import { fixLockedSound } from '../utils/fixLockedSound';
import { addAssetsToLoader } from '../handlers/addAssetsToLoader';
import { prepareTintedBurstFx } from '../handlers/prepareTintedBurstFx';
import { prepareFieldGfx } from '../handlers/prepareFieldGfx';
import { GameState } from './GameState';
//import * as GBCXPromo from 'GBCXPromo';

declare const GBCXPromo;


export class Boot extends Phaser.State {
  public static key: string = 'Boot';

  public init() {

    game.config.backgroundColor = GBCXPromo.storage.getStorageValue('backgroundColor', '#3e4272');

    game.arrowPointer = GBCXPromo.storage.getStorageValue('pointer', false);

    document.body.style.backgroundColor = game.config.backgroundColor;
    game.resizeGame();

    game.input.mouse.enabled = !game.device.mspointer;

    game.renderer.renderSession.roundPixels = true;

    fixLockedSound(game);

    //@ts-ignore
    game.sound.mute = GBCXPromo.storage.getStorageValue('mute', false);

     //@ts-ignore
    game.gameDifficultyLevel = GBCXPromo.storage.getStorageValue('gameDifficultyLevel', 0);

    game.scale.pageAlignHorizontally = true;
    game.scale.scaleMode = Phaser.ScaleManager.SHOW_ALL;
    game.stage.backgroundColor = 0x000000;
    game.input.maxPointers = 1;
    game.stage.disableVisibilityChange = false;
    game.tweens.frameBased = true;
    game.time.advancedTiming = true;

    let oldW = window.innerWidth;
    let oldH = window.innerWidth;

    game.scale.setResizeCallback(function() {
      if (oldW != window.innerWidth || oldH != window.innerHeight) {
        oldW = window.innerWidth;
        oldH = window.innerHeight;
        game.resizeGame();
      }
    }, null);
  }

  public preload() {
    this.load.onFileComplete.add((progress) => {
       //@ts-ignore
      GBCXPromo.loading.setProgress(progress);
    });

    addAssetsToLoader(this.load);
  }

  public create() {
    prepareTintedBurstFx();
    prepareFieldGfx();
    game.state.start(GameState.key);
    console.log("game created...")
     //@ts-ignore
    /*GBCXPromo.loading.finished().then(() => {
       //@ts-ignore
      GBCXPromo.xpromo.showLoginXPromo();
    });*/
  }
}
